import { render, staticRenderFns } from "./LabelPrinter.vue?vue&type=template&id=16f3576a&scoped=true"
import script from "./LabelPrinter.vue?vue&type=script&lang=js"
export * from "./LabelPrinter.vue?vue&type=script&lang=js"
import style0 from "./LabelPrinter.vue?vue&type=style&index=0&id=16f3576a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3576a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f3576a')) {
      api.createRecord('16f3576a', component.options)
    } else {
      api.reload('16f3576a', component.options)
    }
    module.hot.accept("./LabelPrinter.vue?vue&type=template&id=16f3576a&scoped=true", function () {
      api.rerender('16f3576a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/LabelPrinter.vue"
export default component.exports